(function () {
    console.log('CUSTOM PRDUCT --->');

    _sortSizeButtons();
    /* setTimeout(function() {
        _sortSizeButtons();
    }, 1000); */

    function _sortSizeButtons() {
        const SIZE_MAP = [
          "J2XS",
          "JXXS",
          "JXS",
          "JS",
          "JM",
          "JL",
          "JXL",
          "JXXL",
          "J2XL",
          "JXXXL",
          "J3XL",
          "JXS/S",
          "JXS-S",
          "JS/M",
          "JS-M",
          "JM/L",
          "JM-L",
          "JL/XL",
          "JL-XL",
          "JXL/XXL",
          "JXL-XXL",
          "JXXL/XXXL",
          "JXXL-XXXL",
          "JML",
          "JSM",
          "3XS",
          "2XS",
          "XXS",
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "XXL",
          "2XL",
          "XXXL",
          "3XL",
          "XS/S",
          "XS-S",
          "S/M",
          "S-M",
          "M/L",
          "M-L",
          "L/XL",
          "L-XL",
          "XL/XXL",
          "XL-XXL",
          "XXL/XXXL",
          "XXL-XXXL",
          "ML",
          "SM",
          "MID",
          "4XS",
          "LOW",
          "S-L",
          "LXXL",
          "53MM",
          "52MM",
          "54MM",
          "55MM",
          "56MM",
          "51MM",
          "50MM",
          "57MM",
          "60MM",
          "58MM",
          "2XXS",
          "XL2L"
        ];
      
        var myVariants = new Array(SIZE_MAP.length);
      
        const line_item_data = document.querySelectorAll(".product-variant-picker-block .custom-input");
        // console.log('line_item_data', line_item_data);
      
        /*
              console.log('beks1', $list[0]);
              console.log('beks2', $($list[0]));
              console.log('beks3', $($list[0]).data("gift-card"));*/
      
        if (
            line_item_data[0].value.toString().match(SIZE_MAP.join("|"))
        ) {
            line_item_data.forEach((el, i) => {
            let $value = el.value;
                myVariants[_.indexOf(SIZE_MAP, $value)] = $value;
            });
        
            myVariants = _.compact(myVariants);
        
            line_item_data.forEach((el, i) => {
              console.log('el', el);
                let $el = el;
                $el.parentNode.style.order = _.indexOf(myVariants, $el.value) + 1;
            });
        } else {
          let numericals = [];
      
          line_item_data.forEach((el, i) => {
            /* console.log('el', el); */
            let $el = el;
            let val = $el.value.toString();
      
            if (val.match(/\s(?=[1-9]\/)/)) {
                console.log('A');
              /*
                              7 1/4
                          */
              val = eval(val.replace(" ", "+"));
            } else {
                console.log('B');
              /*
                              3 anni
                              3s
                              13_5C
                              7Y
                              12-13.5
                          */
              val = parseFloat(val.replace(/(_|,)/g, ".").replace(/[^\d.]/g, ""));
            }
      
            if (isNaN(val)) {
              val = 0;
            }
      
            numericals.push({
              val: val,
              i: i,
            });
          });
      
          /* console.log('numericals', numericals); */
          let numericals2 = [...numericals].sort(function (a, b) {
            return a.val - b.val;
          });
      
          /* console.log('numericals2', numericals2); */
          for (var i = 0; i < numericals2.length; i++) {
            line_item_data[numericals2[i].i].parentNode.style.order = i;
          }
        }
    }
})();